export const DIAGRAM_ERROR_TYPES = {
    NO_CONFIG_SET: "NO_CONFIG_SET",
    FORBIDDEN_CONNECTOR: "FORBIDDEN_CONNECTOR",
    INVALID_MINIMUM_PLUGIN_INCOMING: "INVALID_MINIMUM_PLUGIN_INCOMING",
    INVALID_MINIMUM_PLUGIN_OUTGOING: "INVALID_MINIMUM_PLUGIN_OUTGOING",
    INVALID_MAXIMUM_PLUGIN_INCOMING: "INVALID_MAXIMUM_PLUGIN_INCOMING",
    INVALID_MAXIMUM_PLUGIN_OUTGOING: "INVALID_MAXIMUM_PLUGIN_OUTGOING",
    INVALID_MANDATORY_COUNT: "INVALID_MANDATORY_COUNT",
    INVALID_MAXIMUM_PLUGIN_INSTANCES: "INVALID_MAXIMUM_PLUGIN_INSTANCES",
    INVALID_MINIMUM_PLUGIN_INSTANCES: "INVALID_MINIMUM_PLUGIN_INSTANCES",
    INVALID_BLOCK_ENDING: "INVALID_BLOCK_ENDING",
    NO_CONTENT: "NO_CONTENT",
    UNCONNECTED_PLUGINS: "UNCONNECTED_PLUGINS",
    LOOP_EMPTY_BODY: "LOOP_EMPTY_BODY",
    NO_GENERAL_START: "NO_GENERAL_START"
};
